import { getRentalConditionsUrl } from './rentalConditions';

export const conditions = {
    avis: {
        latinAmerica: {
            name: 'América Latina',
            Argentina: {
                name: 'Argentina',
                url: getRentalConditionsUrl('AR', 'avis')
            },
            Belize: {
                name: 'Belize',
                url: getRentalConditionsUrl('BZ', 'avis')
            },
            Chile: {
                name: 'Chile',
                url: getRentalConditionsUrl('CL', 'avis')
            },
            Colombia: {
                name: 'Colômbia',
                url: getRentalConditionsUrl('CO', 'avis')
            },
            CostaRica: {
                name: 'Costa Rica',
                url: getRentalConditionsUrl('CR', 'avis')
            },
            ElSalvador: {
                name: 'El Salvador',
                url: getRentalConditionsUrl('EL', 'avis')
            },

            Equador: {
                name: 'Equador',
                url: getRentalConditionsUrl('EC', 'avis')
            },
            Guatemala: {
                name: 'Guatemala',
                url: getRentalConditionsUrl('GT', 'avis')
            },
            Honduras: {
                name: 'Honduras',
                url: getRentalConditionsUrl('HD', 'avis')
            },
            Mexico: {
                name: 'México',
                url: getRentalConditionsUrl('MX', 'avis')
            },
            Nicaragua: {
                name: 'Nicarágua',
                url: getRentalConditionsUrl('NI', 'avis')
            },
            Panama: {
                name: 'Panamá',
                url: getRentalConditionsUrl('PA', 'avis')
            },
            Paraguai: {
                name: 'Paraguai',
                url: getRentalConditionsUrl('PY', 'avis')
            },
            Peru: {
                name: 'Peru',
                url: getRentalConditionsUrl('PE', 'avis')
            },
            Uruguai: {
                name: 'Uruguai',
                url: getRentalConditionsUrl('UY', 'avis')
            },
        },
        caribbean: {
            name: 'Caribe',
            Anguila: {
                name: 'Anguila',
                url: getRentalConditionsUrl('AI', 'avis')
            },
            Aruba: {
                name: 'Aruba',
                url: getRentalConditionsUrl('AB', 'avis')
            },
            Curazao: {
                name: 'Curaçao',
                url: getRentalConditionsUrl('CW', 'avis')
            },
            IlhasCayman: {
                name: 'Ilhas Cayman',
                url: getRentalConditionsUrl('CT', 'avis')
            },
            Jamaica: {
                name: 'Jamaica',
                url: getRentalConditionsUrl('JM', 'avis')
            },
            RepDominicana: {
                name: 'R.Dominicana',
                url: getRentalConditionsUrl('DO', 'avis')
            },

            StBarthelemy: {
                name: 'St. Barthelemy',
                url: getRentalConditionsUrl('BL', 'avis')
            },
            StMaarten: {
                name: 'St. Maarten',
                url: getRentalConditionsUrl('SX', 'avis')
            },
        },
        europe: {
            name: 'Europa',
            Alemania: {
                name: 'Alemanha',
                url: getRentalConditionsUrl('DE', 'avis')
            },
            Austria: {
                name: 'Áustria',
                url: getRentalConditionsUrl('AT', 'avis')
            },
            Belgica: {
                name: 'Bélgica',
                url: getRentalConditionsUrl('BE', 'avis')
            },
            Croacia: {
                name: 'Croacia',
                url: getRentalConditionsUrl('HR', 'avis')
            },
            Espanha: {
                name: 'Espanha',
                url: getRentalConditionsUrl('ES', 'avis')
            },
            Francia: {
                name: 'França',
                url: getRentalConditionsUrl('FR', 'avis')
            },
            Grecia: {
                name: 'Grécia',
                url: getRentalConditionsUrl('GR', 'avis')
            },

            Holanda: {
                name: 'Países Baixos',
                url: getRentalConditionsUrl('NL', 'avis')
            },
            Italia: {
                name: 'Itália',
                url: getRentalConditionsUrl('IT', 'avis')
            },
            Polonia: {
                name: 'Polônia',
                url: getRentalConditionsUrl('PL', 'avis')
            },
            Portugal: {
                name: 'Portugal',
                url: getRentalConditionsUrl('PT', 'avis')
            },
            ReinoUnido: {
                name: 'Reino Unido',
                url: getRentalConditionsUrl('GB', 'avis')
            },
            RepCheca: {
                name: 'República Tcheca ',
                url: getRentalConditionsUrl('CZ', 'avis')
            },

            Suecia: {
                name: 'Suécia',
                url: getRentalConditionsUrl('SE', 'avis')
            },
            Suiza: {
                name: 'Suíça',
                url: getRentalConditionsUrl('CH', 'avis')
            },
        },
        Canada: {
            name: 'Canadá',
            url: getRentalConditionsUrl('CA', 'avis')
        },
        EstadosUnidos: {
            name: 'Estados Unidos ',
            url: getRentalConditionsUrl('US', 'avis')
        },
        Israel: {
            name: 'Israel',
            url: getRentalConditionsUrl('IL', 'avis')
        }
    },


    budget: {
        latinAmerica: {
            name: 'América Latina',
            Argentina: {
                name: 'Argentina',
                url: getRentalConditionsUrl('AR', 'budget')
            },
            Belize: {
                name: 'Belize',
                url: getRentalConditionsUrl('BZ', 'budget')
            },
            Chile: {
                name: 'Chile',
                url: getRentalConditionsUrl('CL', 'budget')
            },
            Colombia: {
                name: 'Colômbia',
                url: getRentalConditionsUrl('CO', 'budget')
            },
            CostaRica: {
                name: 'Costa Rica',
                url: getRentalConditionsUrl('CR', 'budget')
            },
            ElSalvador: {
                name: 'El Salvador',
                url: getRentalConditionsUrl('EL', 'budget')
            },
            Equador: {
                name: 'Equador',
                url: getRentalConditionsUrl('EC', 'budget')
            },
            Guatemala: {
                name: 'Guatemala',
                url: getRentalConditionsUrl('GT', 'budget')
            },
            Honduras: {
                name: 'Honduras',
                url: getRentalConditionsUrl('HD', 'budget')
            },
            Mexico: {
                name: 'México',
                url: getRentalConditionsUrl('MX', 'budget')
            },
            Nicaragua: {
                name: 'Nicarágua',
                url: getRentalConditionsUrl('NI', 'budget')
            },
            Panama: {
                name: 'Panamá',
                url: getRentalConditionsUrl('PA', 'budget')
            },
            Peru: {
                name: 'Peru',
                url: getRentalConditionsUrl('PE', 'budget')
            },
            Uruguai: {
                name: 'Uruguai',
                url: getRentalConditionsUrl('UY', 'budget')
            },
        },
        caribbean: {
            name: 'Caribe',
            AntíguaEBarbuda: {
                name: 'Antígua e Barbuda',
                url: getRentalConditionsUrl('AG', 'budget')
            },
            Aruba: {
                name: 'Aruba',
                url: getRentalConditionsUrl('AB', 'budget')
            },
            IlhasCayman: {
                name: 'Ilhas Cayman',
                url: getRentalConditionsUrl('CT', 'budget')
            },
            Jamaica: {
                name: 'Jamaica',
                url: getRentalConditionsUrl('JM', 'budget')
            },
            RepDominicana: {
                name: 'R.Dominicana',
                url: getRentalConditionsUrl('DO', 'budget')
            },
        },

        europe: {
            name: 'Europa',
            Alemania: {
                name: 'Alemanha',
                url: getRentalConditionsUrl('DE', 'budget')
            },
            Austria: {
                name: 'Áustria',
                url: getRentalConditionsUrl('AT', 'budget')
            },
            Belgica: {
                name: 'Bélgica',
                url: getRentalConditionsUrl('BE', 'budget')
            },
            Croacia: {
                name: 'Croacia',
                url: getRentalConditionsUrl('HR', 'budget')
            },
            Espanha: {
                name: 'Espanha',
                url: getRentalConditionsUrl('ES', 'budget')
            },
            Francia: {
                name: 'França',
                url: getRentalConditionsUrl('FR', 'budget')
            },
            Grecia: {
                name: 'Grécia',
                url: getRentalConditionsUrl('GR', 'budget')
            },
            Italia: {
                name: 'Itália',
                url: getRentalConditionsUrl('IT', 'budget')
            },
            Portugal: {
                name: 'Portugal',
                url: getRentalConditionsUrl('PT', 'budget')
            },
            ReinoUnido: {
                name: 'Reino Unido',
                url: getRentalConditionsUrl('GB', 'budget')
            },
            Suiza: {
                name: 'Suíça',
                url: getRentalConditionsUrl('CH', 'budget')
            },
        },
        Canada: {
            name: 'Canadá',
            url: getRentalConditionsUrl('CA', 'budget')
        },
        EstadosUnidos: {
            name: 'Estados Unidos ',
            url: getRentalConditionsUrl('US', 'budget')
        },
        Marrocos: {
            name: 'Marrocos',
            url: getRentalConditionsUrl('MA', 'budget')
        }
    },
}